import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULTS = {
  hero_headline: "India Ka Apna Expert Construction Drawing Platform",
  hero_subtext: "2D Floor Plans | Structural Details | Electrical/Plumbing",
  hero_price_badge: "Affordable Plans From ₹8,500/-",
  hero_banner_image: "https://housedesignwala.com/api/files/5538b573-c66d-4c3b-9610-fc37c8046975",
  tagline: "Hum Sirf Ghar Nahi, Khushiyaan Sajate Hain",
  phone: "+91 90507 82248",
  whatsapp_number: "919050785528",
  email: "support@housedesignwala.com",
  logo_image: "https://housedesignwala.com/api/files/18b1b263-2c1d-4631-8cfa-3c743bdb0809",
  countdown_active: true,
};

const SettingsCtx = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [s, setS] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings").then(r => setS({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);
  return <SettingsCtx.Provider value={s}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
